import { cn } from "@/lib/cn";

// Brand mark — a gradient rounded square with a check, plus the wordmark.
//
// The geometry here mirrors src/assets/brand-mark.svg, which is the source every
// generated icon (favicon, Chrome toolbar, the desktop agent's window/tray/exe)
// comes from. It's inline rather than an <img> so it can inherit the theme and
// stay crisp at any size — but if you change one, change the other: they used to
// disagree, which is how the product ended up with four different logos.
// `onDark` is for the permanently-dark surfaces that stay dark in BOTH themes
// (the auth showcase panel). The wordmark's normal `text-slate-900
// dark:text-white` renders near-black on near-black there in light theme, and it
// can't be fixed from the call site: `className` lands on the outer wrapper, and
// cn() doesn't tailwind-merge, so an override would leave text-slate-900 applied.
export default function Logo({ className, showText = true, onDark = false }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <span className="relative grid h-9 w-9 place-items-center rounded-xl bg-gradient-to-br from-brand-400 to-brand-600 shadow-glow">
        <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
          <path
            d="M7.5 12.4l3.4 3.4 6.4-7"
            fill="none"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {/* The hyphen belongs to the wordmark: without it this renders
          "AI-QAEngine", which disagreed with the footer, the legal pages, the
          Razorpay checkout and the assistant — all of which say AI-QA-Engine. */}
      {showText && (
        <span
          className={cn(
            "font-display text-lg font-bold tracking-tight",
            onDark ? "text-white" : "text-slate-900 dark:text-white"
          )}
        >
          AI-QA
          <span className={onDark ? "text-brand-400" : "text-brand-500"}>
            -Engine
          </span>
        </span>
      )}
    </span>
  );
}
